import React, { Fragment } from "react";
import logo4 from "../Firmenlogotei4.png";

export const Logo = ({ logowidth, logoheight }) => {
  const color = "#ca02ab";
  const smallImage = logo4;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={smallImage}
        className="img-responsive"
        alt="logo"
        style={{ height: logoheight }}
      />
    </div>
  );
};
